import React from 'react';

function NoPaymentFound() {
	return (
		<div className="practiceManagementForm" style={{ border: '1px solid #dadada' }}>
			<div className="noDataFound">
				<p>No Payments Found</p>
			</div>
		</div>
	);
}
export default NoPaymentFound;
